/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';
import { Pair } from './pair';

export interface MarketMakingTrade {
  id?: number;
  pairId?: number;
  pair?: Pair;
  price?: number;
  units?: number;
  volume?: number;
  fee?: number;
  feeAssetId?: number;
  feeAsset?: Asset;
  tradeLinePlatformTime?: string;
  tradeLineFixSentTime?: string;
  tradeLineReceivedTime?: string;
  buy?: boolean;
  maker?: boolean;
  execId?: string;
  tag1?: string;
  tag2?: string;
  tag3?: string;
}
